import createStore from "view-ui-admin/src/utils/create-store";
import Model from "@/models/public/entries";

export default createStore({ Model });
